export default __webpack_public_path__ + "static/media/La respuesta varía.35123171.svg";